module.exports = __webpack_public_path__ + "img/42545d8.png";